import {Component, Inject, OnInit} from '@angular/core';
import {Favorite, FavoriteList} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AdService} from '@services/ad.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';
import {AlertService} from '@services/alert.service';
import {TrackingService} from '@services/tracking.service';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class NotesComponent implements OnInit {

    favorite: Favorite;
    user: User = Object.assign({}, EMPTY_USER);
    loading = false;
    comment = '';

    constructor(
        private adService: AdService,
        public dialogRef: MatDialogRef<NotesComponent>,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        public trackingService: TrackingService,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.favorite = this.data.favorite;
        this.user = this.authenticationService.currentUser;
        this.comment = this.favorite.comment;
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.loading = true
        this.favorite.comment = this.comment;
        this.adService.updateFavoriteText(this.favorite, this.favorite.comment, 'comment');
        this.dialogRef.close(this.favorite);
    }
}
